import React from 'react';

import Avatar from './Avatar';
import { NAVY, fmtHora } from '../../utils/chatUtils';

/** Bolha compacta de mensagem para o painel flutuante (só leitura + status).
 *  Reaproveita Avatar e helpers; ações completas ficam na página /chat. */
export const BolhaCompacta = ({ msg, meuId, fotoUrl }) => {
  const meu = msg.autor_id === meuId;
  if (msg.tipo === 'sistema') {
    return <div className="text-center text-2xs text-slate-400 py-1">{msg.texto}</div>;
  }
  return (
    <div className={`flex gap-1.5 ${meu ? 'flex-row-reverse' : ''}`}>
      {!meu && <Avatar nome={msg.autor_nome} id={msg.autor_id} size={26} fotoUrl={fotoUrl} />}
      <div className={`max-w-[80%] flex flex-col ${meu ? 'items-end' : 'items-start'}`}>
        {!meu && <span className="text-2xs text-slate-500 mb-0.5 ml-1">{msg.autor_nome}</span>}
        <div className={`rounded-2xl px-3 py-1.5 ${meu ? 'rounded-br-sm text-white' : 'rounded-bl-sm bg-white border border-slate-200 text-slate-800'}`}
          style={meu ? { background: NAVY } : {}}>
          {msg.deletado ? (
            <span className="italic opacity-60 text-sm">mensagem apagada</span>
          ) : (
            <>
              {msg.anexo && (msg.tipo === 'imagem' || (msg.anexo.mime_type || '').startsWith('image/')) ? (
                <a href={msg.anexo.url} target="_blank" rel="noreferrer" aria-label={`Ver imagem ${msg.anexo.nome}`}>
                  <img src={msg.anexo.url} alt={msg.anexo.nome} className="rounded-lg max-w-[180px] max-h-[180px] object-cover mb-1" />
                </a>
              ) : msg.anexo && (msg.tipo === 'audio' || (msg.anexo.mime_type || '').startsWith('audio/')) ? (
                <div className="mb-1">
                  <audio controls preload="metadata" src={msg.anexo.url} className="w-[200px] max-w-full" aria-label={`Áudio ${msg.anexo.nome || ''}`} />
                  {/* fallback: formato que o navegador não toca (flac/amr/…) ainda é baixável */}
                  <a href={msg.anexo.url} download={msg.anexo.nome || undefined}
                    className={`block text-2xs underline mt-0.5 ${meu ? 'text-white/70' : 'text-slate-500'}`}>Baixar {msg.anexo.nome || 'arquivo'}</a>
                </div>
              ) : msg.anexo && (msg.tipo === 'video' || (msg.anexo.mime_type || '').startsWith('video/')) ? (
                <div className="mb-1">
                  {/* sem <a> em volta: clicar em play/seek não pode abrir outra aba */}
                  <video controls preload="metadata" src={msg.anexo.url} className="rounded-lg max-w-[200px] max-h-[220px]" aria-label={`Vídeo ${msg.anexo.nome || ''}`} />
                  <a href={msg.anexo.url} download={msg.anexo.nome || undefined}
                    className={`block text-2xs underline mt-0.5 ${meu ? 'text-white/70' : 'text-slate-500'}`}>Baixar {msg.anexo.nome || 'arquivo'}</a>
                </div>
              ) : msg.anexo ? (
                <a href={msg.anexo.url} target="_blank" rel="noreferrer"
                  className={`flex items-center gap-1 text-sm underline ${meu ? 'text-white' : 'text-primary'}`}>
                  📎 {msg.anexo.nome}
                </a>
              ) : null}
              {msg.texto && <div className="text-sm whitespace-pre-wrap break-words">{msg.texto}</div>}
            </>
          )}
          <div className={`text-2xs mt-0.5 text-right flex items-center gap-1 justify-end ${meu ? 'text-white/60' : 'text-slate-400'}`}>
            <span>{fmtHora(msg.created_at)}{msg.editado && ' (editado)'}</span>
            {meu && msg._status === 'enviando' && <span title="Enviando">⏳</span>}
            {meu && msg._status === 'falhou' && <span title="Falha ao enviar" className="text-red-300">⚠</span>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BolhaCompacta;
